export default __webpack_public_path__ + "static/media/pexels-skitterphoto-9253.9273eb51.png";